module.exports = __webpack_public_path__ + "img/app-item-uploading-dark.97ccf20a.svg";